/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountsettings_Createdat2Inputs */

const zh_accountsettings_createdat2 = /** @type {(inputs: Accountsettings_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建时间`)
};

const en_accountsettings_createdat2 = /** @type {(inputs: Accountsettings_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created At`)
};

const es_accountsettings_createdat2 = /** @type {(inputs: Accountsettings_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de creación`)
};

/**
* | output |
* | --- |
* | "Created At" |
*
* @param {Accountsettings_Createdat2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const accountsettings_createdat2 = /** @type {((inputs?: Accountsettings_Createdat2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountsettings_Createdat2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_accountsettings_createdat2(inputs)
	if (locale === "en") return en_accountsettings_createdat2(inputs)
	return es_accountsettings_createdat2(inputs)
});
export { accountsettings_createdat2 as "accountSettings_createdAt" }